/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sub_Dashboard_Cancel_Downgrade_ErrorInputs */



/**
* | output |
* | --- |
* | "Could not cancel downgrade." |
*
* @param {Sub_Dashboard_Cancel_Downgrade_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sub_dashboard_cancel_downgrade_error = /** @type {((inputs?: Sub_Dashboard_Cancel_Downgrade_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sub_Dashboard_Cancel_Downgrade_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Downgrade konnte nicht abgebrochen werden.")
	return /** @type {LocalizedString} */ ("Could not cancel downgrade.")
});